/* RWW bulk tiers 2026-10-13 (idea #9): live "next quantity break" message on every cart line (drawer + /cart).
   Placeholders: snippets/rww-bulk-tiers.liquid (mode 'nudge') inside snippets/cart-items.liquid, one per line, keyed by
   the line key. Nothing is hard-coded here:
   - tiers  = the Bulk Tier Pricing RWW app's own table (/products/<handle>?view=rww-tiers, the app block), cached 10 min
              (the same discount configuration the app's function applies; it is per size = per cart line)
   - saving = the cart's real discount (original_line_price - final_line_price from /cart.js)
   Re-rendered after every cart request the theme makes (fetch hook + its events) and whenever the theme swaps the
   cart markup (MutationObserver), so it always matches the current quantity. Loaded once from sections/cart-drawer.liquid. */
(function () {
  'use strict';
  if (window.__rwwBulkTiers) return; window.__rwwBulkTiers = 1;
  var KEY = 'rww-tiers-cart-v1', TTL = 10 * 60 * 1000;
  var cart = null, tiers = null, tiersLoading = null, timer = 0;

  function money(c) { var s = (Math.round(c) / 100).toFixed(2).split('.'); return '$' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1]; }
  function store(v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { return null; } }
  function parse(root) {
    var out = [];
    (root || document).querySelectorAll('.qb-row[data-qb-min][data-qb-value]').forEach(function (r) {
      var min = parseInt(r.getAttribute('data-qb-min'), 10), pct = parseFloat(r.getAttribute('data-qb-value'));
      if (r.getAttribute('data-qb-type') === 'percentage' && pct >= 1 && min > 1 && !out.some(function (t) { return t.min === min; })) out.push({ min: min, pct: pct });
    });
    return out.sort(function (a, b) { return a.min - b.min; });
  }
  function loadTiers(handle) {
    if (tiers) return Promise.resolve(tiers);
    var onPage = parse(document.querySelector('[data-qb-root]'));
    if (onPage.length) { tiers = onPage; return Promise.resolve(tiers); }
    var c = store();
    if (c && c.t > Date.now() - TTL && c.tiers && c.tiers.length) { tiers = c.tiers; return Promise.resolve(tiers); }
    if (!handle) return Promise.resolve(null);
    if (!tiersLoading) {
      tiersLoading = fetch('/products/' + encodeURIComponent(handle) + '?view=rww-tiers', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var t = parse(new DOMParser().parseFromString(html, 'text/html'));
          if (t.length) { tiers = t; store({ t: Date.now(), tiers: t }); }
          return tiers;
        })
        .catch(function () { return null; })
        .then(function (t) { tiersLoading = null; return t; });
    }
    return tiersLoading;
  }

  function message(item) {
    var parts = [], q = item.quantity, saved = item.original_line_price - item.final_line_price, next = null;
    if (saved > 0) parts.push('<span class="rbt-nudge__ok">&#10003; Bulk price applied: you save ' + money(saved) + '.</span>');
    (tiers || []).forEach(function (t) { if (!next && q < t.min) next = t; });
    if (next && item.original_price > 0) {
      var each = Math.round(item.original_price * (100 - next.pct) / 100);
      parts.push('Add <b>' + (next.min - q).toLocaleString('en-US') + '</b> more for <b>' + next.pct + '% off</b> this size (' + money(each) + ' each).');
    }
    return parts.join('<br>');
  }

  function render() {
    if (!cart) return;
    var byKey = {};
    cart.items.forEach(function (i) { byKey[i.key] = i; });
    document.querySelectorAll('[data-rbt-nudge]').forEach(function (el) {
      var it = byKey[el.getAttribute('data-key')];
      if (!it) return;  // markup newer than our cart: the fetch hook / observer refetches
      var html = message(it);
      if (el.innerHTML !== html) el.innerHTML = html;
      el.hidden = !html;
    });
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (c) {
        cart = c;
        var handle = c.items.length ? c.items[0].handle : null;
        render();
        return loadTiers(handle).then(render);
      })
      .catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 120); }

  // Every cart request the theme (or an app) makes: refresh once it has answered.
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (window.fetch) {
    var f0 = window.fetch;
    window.fetch = function (input) {
      var p = f0.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_RE.test(url.split('#')[0])) p.then(schedule, schedule);
      } catch (e) {}
      return p;
    };
  }
  var open0 = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    try { if (CART_RE.test(String(url))) this.addEventListener('loadend', schedule); } catch (e) {}
    return open0.apply(this, arguments);
  };
  ['on:line-item:change', 'on:cart:add', 'on:cart:change', 'on:cart-drawer:before-open', 'pageshow'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
  // The theme replaces the cart markup with innerHTML after each change: fill the new placeholders.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType === 1 && (n.matches('[data-rbt-nudge]') || n.querySelector('[data-rbt-nudge]'))) { render(); schedule(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
